import { ThreeColumnLayout } from '../layout/ThreeColumnLayout';

export function PublicLayout() {
  return <ThreeColumnLayout />;
}
